import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { TrxservicesCardPage } from './trxservices-card.page';

const routes: Routes = [
  {
    path: '',
    component: TrxservicesCardPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class TrxservicesCardPageRoutingModule {}
